module.exports = __webpack_public_path__ + "img/chrome_webstore_icon.d0813aa2.png";